//import { routerReducer } from 'react-router-redux';
import { authReducer, regReducer, cloakReducer, licenseReducer, groupReducer, certReducer, cloakQRReducer } from 'cloak-file-sdk-web';

import { settingsReducer } from './settingsReducer'
import { upgradeReducer  } from './upgradeReducer'
import { combineReducers } from 'redux';

const reducer = combineReducers({
  //router: routerReducer,
  auth: authReducer,
  reg: regReducer,
  cert: certReducer,
  cloak: cloakReducer,
  lic: licenseReducer,
  config: settingsReducer,
  group: groupReducer,
  qr: cloakQRReducer,
  upgrade: upgradeReducer
});

export default reducer;
